var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery } from '@apollo/client/react';
import { useAccount } from 'shared/domains/users';
import { LogoUrlExternalDocument, LogoUrlInternalDocument } from './LogoUrl.gql';
export const useLogoUrl = (documentId) => {
    const { data: accountData } = useAccount();
    const isExternal = process.env.WEB_CLIENT === 'external';
    const [queryInternal, stateInternal] = useLazyQuery(LogoUrlInternalDocument);
    const [queryExternal, stateExternal] = useLazyQuery(LogoUrlExternalDocument);
    const getUrl = (path) => `${process.env.CDN_URL}/${path}`;
    const getLogoUrlInternal = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { data } = yield queryInternal({ variables: { companyId: accountData.companyId } });
        const logoPath = (_a = data === null || data === void 0 ? void 0 : data.company) === null || _a === void 0 ? void 0 : _a.logoPath;
        const logoUploaded = (_b = data === null || data === void 0 ? void 0 : data.company) === null || _b === void 0 ? void 0 : _b.logoUploaded;
        const logoUrl = logoUploaded && logoPath ? getUrl(logoPath) : undefined;
        return logoUrl;
    });
    const getLogoUrlExternal = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield queryExternal({ variables: { documentId } });
        const invite = data === null || data === void 0 ? void 0 : data.invites[0];
        if (!invite) {
            return undefined;
        }
        const { logoPath, logoUploaded } = invite.company;
        const logoUrl = logoUploaded && logoPath ? getUrl(logoPath) : undefined;
        return logoUrl;
    });
    const internal = [getLogoUrlInternal, stateInternal];
    const external = [getLogoUrlExternal, stateExternal];
    return isExternal ? external : internal;
};
